import { History } from 'history';

const goTo = ({
  history,
  entityId,
}: {
  history: History;
  entityId: string;
}): void => {
  if (entityId) {
    history.go(-2);
  } else {
    history.goBack();
  }
};

export default goTo;
